import React, { useContext } from "react";
import styled from "styled-components";
import Button from "common/Buttons/Button";
import { AffiliationContext } from "features/affiliation/Affiliation.context";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface CreatePayoutButtonProps {
  /** The view's primary action (payouts tab); a plain button otherwise. */
  primary?: boolean;
  /** Full width (phone rows). */
  block?: boolean;
}

/**
 * "Create payout". Without a payout method it still opens the explanation,
 * so it only looks disabled.
 */
export const CreatePayoutButton = ({
  primary,
  block,
}: CreatePayoutButtonProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const { onCreatePayoutClick, hasPayoutMethod } =
    useContext(AffiliationContext)!;

  return (
    <PayoutButton
      type={primary ? "primary" : "default"}
      $disabled={!hasPayoutMethod}
      $block={block}
      onClick={onCreatePayoutClick}
    >
      {t("actions.create_payout")}
    </PayoutButton>
  );
};

const PayoutButton = styled(Button)<{ $block?: boolean }>`
  &.ant-btn {
    flex: none;
    height: 32px;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 500;
    box-shadow: none;
    ${(p) => p.$block && "width: 100%; height: 40px;"}
  }
`;
